// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import router from './router'
import App from './App'
import 'styles/reset.css'
import 'styles/iconfont.css'
import '../node_modules/element-ui/lib/theme-chalk/index.css'
import ElementUI from 'element-ui'
import axios from 'axios'
import 'babel-polyfill'
import qs from 'qs'
import VueI18n from 'vue-i18n'

import {setCookie, getCookie, delCookie} from '@/util/cookie.js'
// import { Table } from 'element-ui'

// 关闭生产模式下给出的提示
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.prototype.$qs = qs
Vue.prototype.$axios = axios
axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded'
Vue.prototype.$cookieStore = {
  setCookie,
  getCookie,
  delCookie
}
Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: localStorage.lan ? localStorage.getItem('lan') : 'en', // 设置语言
  messages: {
    en: {
      register: 'I want to cooperate',
      forget: 'Forgot password',
      mail_phone: 'Mailbox/Mobile phone number',
      password: 'Please enter a user password',
      form_text: 'Agent Sign in',
      login_btn: 'SIGN IN',
      checkAccount: 'Incorrect account or password, please re-enter!'
    },
    zh: {
      register: '我要合作',
      forget: '忘记密码',
      mail_phone: '邮箱/手机号',
      password: '请输入用户密码',
      form_text: '代理人登录',
      login_btn: '登录',
      checkAccount: 'Incorrect account or password, please re-enter! 账号或密码不正确，请重新输入！'
    },
    hk: {
      register: '我要合作',
      forget: '忘記密碼',
      mail_phone: '郵箱/手機號',
      password: '請輸入用戶密碼',
      form_text: '代理人登錄',
      login_btn: '登錄',
      checkAccount: 'Incorrect account or password, please re-enter! 賬號或密碼不正確，請重新輸入！'
    }
  }
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n, // 注册
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js